<script setup lang="ts">
import Container from '../Container.vue';
import EntryCard from './Card.vue';

const props = defineProps<{
	isCenter?: boolean;
}>();
</script>

<template>
	<Container size="xl">
		<div class="entry" :class="{ 'entry--is-center': props.isCenter }">
			<EntryCard>
				<template v-if="$slots.header" #header>
					<slot name="header" />
				</template>

				<slot />
			</EntryCard>

			<slot name="footer" />
		</div>
	</Container>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.entry
	{
		@include flex(null, null, var(--spacing-lg));
		flex-direction:column;

		@include responsive(md)
		{
			gap:var(--spacing-2xl);
		}

		&--is-center
		{
			align-items:center;
		}
	}
}
</style>
